import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import _ from 'lodash';
import { Contacto } from 'src/app/global/interfaces/contacto';
import { InstalacionDireccion } from 'src/app/global/interfaces/instalacion-direccion';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { ValidaEdicionResponse } from 'src/app/global/interfaces/valida-edicion-paso-tres-response';
import { FlujosPaso3Service } from 'src/app/global/services/flujos-paso-3.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { ContactoServiceVM } from 'src/app/view-model/services/contacto.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { InstalacionDireccionServiceVM } from 'src/app/view-model/services/instalacion-direccion.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';

@Component({
  selector: 'app-datos-entrega',
  templateUrl: './datos-entrega.component.html',
  styleUrls: ['./datos-entrega.component.scss']
})
export class DatosEntregaComponent implements OnInit {

  get flujo() {return this.flujosPaso3Service.datosAgenda; }

  constructor(private contactoService: ContactoServiceVM,
              private dialogService: DialogService,
              private dirInstallService: InstalacionDireccionServiceVM,
              private validaEdicionService: ValidacionEdicionServiceVM,
              private flujosPaso3Service: FlujosPaso3Service,
              private localStorageService: LocalStorageService) { }
  dataPaso3: Paso3;

  metropolitana: any;
  public datosContacto: Contacto;
  public datosDireccion: InstalacionDireccion;
  public permiteEdicion: boolean;
  public poseeAgenda: boolean;
  public loading: boolean;
  public loadingDir: boolean;
  public editarContacto: boolean;
  public editarDireccion: boolean;
  public nombreContactoRecibe: string;
  public numeroContactoRecibe: number;
  public validaEdicion: ValidaEdicionResponse;


  public direccionEntrega = new FormGroup({
    direccionCompleta: new FormControl('', [Validators.required]),
    region: new FormControl('', [Validators.required]),
    comuna: new FormControl('', [Validators.required]),
    avenidaCallePasaje: new FormControl('', [Validators.required]),
    numeroCalle: new FormControl('', [Validators.required]),
    numeroLocal: new FormControl('')

  });

  public recibeEntrega = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    telefono: new FormControl('', [Validators.required])

  });

  ngOnInit() {
    this.editarContacto = false;
    this.editarDireccion = false;
    this.dataPaso3 = this.localStorageService.getPaso3();
    if (this.dataPaso3.datosAgenda === undefined) {
      this.poseeAgenda = false;
    } else {
      this.poseeAgenda = true;
    }
    // this.permiteEdicion = false;
    // this.getValidaEdicion();
    // this.getContacto();
    // this.getDireccionInstalacion();
  }



  private getValidaEdicion() {

    const cbOK = response => {
      this.validaEdicion = response;
      if (this.validaEdicion.data) {
        this.permiteEdicion = true;
      }
    };

    const cbError = error => {
      console.error(error);
    };

    this.validaEdicionService.getValidacionEdicion().subscribe(cbOK, cbError);
  }

  private getDireccionInstalacion() {
    this.loadingDir = true;

    const cbOK = response => {
      this.loadingDir = false;
      this.datosDireccion = response;
    };

    const cbError = error => {
      this.loadingDir = false;
      console.error(error);
    };

    this.dirInstallService.obtenerDireccionInstalacion().subscribe(cbOK, cbError);
  }

  private getContacto(): void {
    this.loading = true;

    const cbOK = response => {
      this.nombreContactoRecibe = _.get(response, 'nombres.nombres') + ' ' + _.get(response, 'nombres.apellidoPaterno');
      this.numeroContactoRecibe = _.get(response, 'telefono');
      this.loading = false;
    };

    const cbError = error => {
      this.loading = false;
      console.error(error);
    };

    this.contactoService.getContactoAgendamiento().subscribe(cbOK, cbError);
  }

  public postContacto(): void {
    if (!this.recibeEntrega.valid) {
      return;
    }
    const datosContacto: Contacto = {
        run: null,
        nombres: {
          nombres: this.recibeEntrega.get('nombre').value,
          apellidoPaterno: this.recibeEntrega.get('primerApellido').value,
          apellidoMaterno: null
        },
        correo: null,
        telefono: this.recibeEntrega.get('telefono').value
    };

    const cbOK = response => {
      if (_.get(response, 'data') === 'OK' && _.get(response, 'indicador') === 'OK') {
        this.nombreContactoRecibe = this.recibeEntrega.get('nombre').value + ' ' + this.recibeEntrega.get('primerApellido').value;
        this.numeroContactoRecibe = this.recibeEntrega.get('telefono').value;
        const data = {
          title: _.get(response, 'mensaje.titulo'),
          description: _.get(response, 'mensaje.contenido'),
          actionButton: 'Cerrar',
          icon: '../../../assets/icons/icon-informacion.svg'
        };
        const dialogRef = this.dialogService.openOneActionDialog({data});
        dialogRef.afterClosed().subscribe( r => {
          if (_.get(r, 'action') === 'OK') {
            this.recibeEntrega.reset();
            this.editarContacto = false;
          }
        });
      }
    };

    const cbError = error => {
      console.error(error);
    };

    this.contactoService.postContactoAgendamiento(datosContacto).subscribe(cbOK, cbError);
  }

  public actualizarDireccion() {

    if (!this.direccionEntrega.valid) {
      return;
    }

    const direccion: InstalacionDireccion = {
      direccion: this.direccionEntrega.get('direccionCompleta').value,
      numero: this.direccionEntrega.get('numeroCalle').value,
      complemento: this.direccionEntrega.get('avenidaCallePasaje').value,
      idComuna: 1
    };

    const cbOK = response => {
      if (_.get(response, 'indicador') === 'OK') {
        const data = {
          actionButton: 'Cerrar',
          description: _.get(response, 'mensaje.contenido'),
          title: _.get(response, 'mensaje.titulo'),
          icon: '../../../assets/icons/icon-informacion.svg'
        };
        const dialogRef = this.dialogService.openOneActionDialog({data});
        dialogRef.afterClosed().subscribe( r => {
          if (_.get(r, 'action') === 'OK') {
            this.recibeEntrega.reset();
            this.editarContacto = false;
          }
        });
      }
    };

    const cbError = error => {
      console.error(error);
    };

    this.dirInstallService.actualizarDireccionInstalacion(direccion).subscribe(cbOK, cbError);

  }

  public edContacto(): void {
    if (!this.editarContacto) {
      this.recibeEntrega.reset();
      this.editarContacto = true;
    }
  }

  public backContacto(): void {
    this.recibeEntrega.reset();
    this.editarContacto = false;
  }

  public edDireccion(): void {
    this.direccionEntrega.reset();
    this.editarDireccion = true;
  }

  public backDireccion(): void {
    this.direccionEntrega.reset();
    this.editarDireccion = false;
  }

}
